<template>
  <div class="loader-wrapper" v-if="loading">
    <div class="loader-index"><span></span></div>
    <svg>
      <defs></defs>
      <filter id="goo">
        <fegaussianblur in="SourceGraphic" stddeviation="11" result="blur"></fegaussianblur>
        <fecolormatrix in="blur" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9" result="goo"> </fecolormatrix>
      </filter>
    </svg>
  </div>
  <div v-else>
    <!-- <div class="page-wrapper" id="pageWrapper" :class="{'horizontal-wrapper':sidebar=='horizontal-wrapper','compact-wrapper':sidebar=='compact-sidebar1'}"> -->
    <div class="page-wrapper" id="pageWrapper" :class="layoutobj">
      <div class="page-header" :class="{ close_icon:!togglesidebar }">
        <Header   @clicked="sidebar_toggle"  />
      </div>
      
      <div class="page-body-wrapper">
        <div class="bg-overlay" :class="{active: activeoverlay }" @click="removeoverlay()"></div>
        <div class="sidebar-wrapper" :class="[{ close_icon : !togglesidebar }]" :sidebar-layout="svg=='stroke-svg'?'stroke-svg':'fill-svg'">
          <Sidebar @clicked="sidebar_toggle" />
        </div>
        <div class="page-body" @click="hidesecondmenu()">
          <transition name="fadeIn" enter-active-class="animated fadeIn">
           <router-view class="view"></router-view>
          </transition>
        </div>
        <Footer/>
      </div>
      <!-- <Customizer/> -->
      <TapTop/>
    </div>
    
  </div>
</template>

<script>
  import { storeToRefs } from 'pinia';
  import { useMenuStore } from '@/stores/menu';
  import { useLayoutStore } from '@/stores/layout';
  
  import { layoutClasses } from '../constants/layout';
  import Header from './header';
  import Sidebar from './sidebar';
  import Footer from './footer.vue';
  // import Customizer from './customizer';
  import TapTop from './tapTop.vue';

  export default {
  //   name: 'mainPage',
    components:{
      Header,
      Sidebar,
      Footer,
      // Customizer,
      TapTop
    },
    setup() {
      const menuStore = useMenuStore();
      const layoutStore = useLayoutStore();
      const { togglesidebar, activeoverlay } = storeToRefs(menuStore);
      const { layout } = storeToRefs(layoutStore);
      
      return {
        menuStore,
        layoutStore,
        togglesidebar,
        activeoverlay,
        layout
      };
    },
    data(){
      return{
        loading: true,
        mobileheader_toggle_var: false,
        sidebar_toggle_var: false,
        horizontal_Sidebar: true,
        resized:false,
        layoutobj:{}
      };
    },
    watch:{
      '$route' (){
        this.menuStore.cerrarSidebarMovil();
        this.loading = true;
        this.$nextTick(() => {
          this.loading = false;
        });
        this.menuStore.data.filter(items => {
          if (items.path === this.$route.path)
            this.menuStore.setActiveRoute(items);
          if (!items.children) return false;
          items.children.filter(subItems => {
            if (subItems.path === this.$route.path)
              this.menuStore.setActiveRoute(subItems);
            if (!subItems.children) return false;
            subItems.children.filter(subSubItems => {
              if (subSubItems.path === this.$route.path)
                this.menuStore.setActiveRoute(subSubItems);
            });
          });
        });
        this.layoutobj = layoutClasses.find((item) => Object.keys(item).pop() === this.layoutStore.layout.settings.layout);
      console.log("layobj==>",this.layoutobj)

        if((this.menuStore.esMovil && this.layoutStore.layout.settings.layout === 'LosAngeles') || (this.menuStore.esMovil && this.layoutStore.layout.settings.layout === 'Singapore') || (this.menuStore.esMovil && this.layoutStore.layout.settings.layout === 'Barcelona')) {
          const newlayout = JSON.parse(JSON.stringify(this.layoutobj).replace('horizontal-wrapper', 'compact-wrapper'));
      // console.log("newlayobj==>",newlayout)

          this.layoutobj = JSON.parse(JSON.stringify(newlayout))[this.layoutStore.layout.settings.layout];
        } else  {
          this.layoutobj = JSON.parse(JSON.stringify(this.layoutobj))[this.layoutStore.layout.settings.layout]; 
        }
      },
      sidebar_toggle_var: function (){
        this.resized = (this.width <= 991) ? !this.sidebar_toggle_var : this.sidebar_toggle_var;      
      }
    },
    created(){
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
      this.resized = this.sidebar_toggle_var;
      this.layoutStore.set();
      // this.$router.replace({ 'query': null }).catch(err => err);
      this.layoutStore.layout.settings.layout = this.$route.query.layout? this.$route.query.layout : 'Dubai';
      this.layoutobj = layoutClasses.find((item) => Object.keys(item).pop() === this.layoutStore.layout.settings.layout);
      this.layoutobj = JSON.parse(JSON.stringify(this.layoutobj))[this.layoutStore.layout.settings.layout]; 

    },
    methods:{
      sidebar_toggle(value) {
        this.sidebar_toggle_var = !value;
      },
      mobiletoggle_toggle(value) {
        this.mobileheader_toggle_var = value;
      },
      handleResize() {
        this.menuStore.resizetoggle();
      },
      removeoverlay() {
        this.menuStore.activeoverlay = false;
        this.menuStore.cerrarSidebarMovil();
        this.menuStore.data.filter(menuItem => {
          menuItem.active = false;
        });
      }, 
      hidesecondmenu() {
          // layoutobj is set in this component; guard against undefined and ensure string split is safe
          const layoutStr = String(this.layoutobj || '');
          if (layoutStr.split(' ').includes('compact-sidebar')) {
            this.menuStore.data.filter(menuItem => {
              menuItem.active = false;
            });
          }
        this.menuStore.cerrarSidebarMovil();
      }
    },
    beforeUnmount() {
      window.removeEventListener('resize', this.handleResize);
    },
    mounted() {
      // setTimeout(()=>{
        this.loading = false;

      // },2000)

  }
  };
</script>

